
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// Components

import { Button }from '@cmsgov/design-system';

import ModalHeader from '@common-components/headers/ModalHeader';

const ViewImageModal = props => {

    const {
        modalHeaderProps,
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                src
            }
        },
        secondaryTopAnchors: [
            anchor_1
        ],
        boundAnchor
    } = props;

    return (
        <Fragment>
            <ModalHeader { ...{ ...modalHeaderProps, hideCloseIcon: true } } />
            <div className = 'gi-modal__body' id={`${modalHeaderProps.modalId}_body`}>
                <img alt = 'Uploaded document' src={src} />
            </div>
            <div className = 'gi-modal__controls'>
                <Button
                    className = 'usa-button gi-button gi-button__primary'
                    inputRef = { boundAnchor(anchor_1) }
                    onClick = { hideModal }
                >
                    <FormattedMessage id = 'button.close'/>
                </Button>
            </div>
        </Fragment>
    );
};

export default ViewImageModal;